<template>
  <el-dialog
    title="召回原因"
    :visible.sync="isShow"
    destroy-on-close
    width="400px"
    @close="closeDialog"
  >
    <el-form ref="applyForm" :model="formData" :rules="rules" label-width="100px">
      <el-form-item prop="retrieveReason" class="reason-wrap">
        <el-input
          v-model="formData.retrieveReason"
          :autosize="{ minRows: 4, maxRows: 6}"
          type="textarea"
          placeholder="请输入召回原因"
          max-length="200"
          show-word-limit
          style="width: 100%;"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="mini" :loading="isLoading" @click="closeDialog">取消</el-button>
      <el-button type="primary" size="mini" :loading="isLoading" @click="submitData">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { retrieveCreditControl } from '@/API/creditAxios.js';

export default {
  data () {
    return {
      isShow: false,
      formData: { orderId: '', retrieveReason: '' },
      isLoading: false,
      rules: { retrieveReason: [{ required: true, message: '召回原因不能为空' }] }
    };
  },

  methods: {
    openDialog (orderId) {
      this.formData.orderId = orderId;
      this.isShow = true;
    },

    closeDialog () {
      this.isShow = false;
      this.$refs.applyForm.resetFields();
    },

    submitData () {
      this.$refs.applyForm.validate((vaild) => {
        if (vaild) {
          this.isLoading = true;
          retrieveCreditControl(this.formData)
            .then((res) => {
              this.isLoading = false;
              let { status, data } = res.data;
              if (status === '200') {
                this.closeDialog();
                this.$message.success('召回成功');
                this.$emit('on-ok', data);
              } else {
                this.$message.error(res.data.err);
              }
            }).catch(() => {
              this.isLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.reason-wrap ::v-deep .el-form-item__content{
  margin-left: 0 !important;
}
:deep(.el-dialog__header){
  background-color: #fff;
  border-bottom: 1px solid #EBEEF5;
}
:deep(.el-dialog__body){
  padding-bottom: 10px !important;
}
</style>
